module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/except-mobile_12f8c3.mp4";